<div class="container-fuild">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title">
            <h5 class="mb-0">Processing Information</h5>
            <p class="mb-0">Enter the following Processing Information</p>
        </div>
        
        <div class="col-md-4 editBtn headerSubPortion px-0"> 
            <ul>
              <li class="col-auto px-0 firstPortion"> 
                <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
              </li>
              <li class="col-auto pr-0 pl-2 secondPortion">
                <lib-maximize-dialog-library
                [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
            <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
              </li>
            </ul>
          </div>
    </div>
    <div class="row">
        <div class="col-md-12 p-0">
            <lib-assigning-task-library [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event
            )">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>
    <form [formGroup]="procesingInformationForm" (ngSubmit)="postProcessingInformation()" class="pb-3 pt-2">
        <div class="main-body footer-adjust">
            <div class="row mb-3" *ngIf="(subTaskDetails.immClassification === 'EB-1a' || this.subTaskDetails.immClassificationCode === 'EB1ALIENSELF')">
                <div class="col-md-4 processing-dropdown">
                    <label class="label-cls required"> Field of Extraordinary Ability </label>
                    <p-dropdown appendTo="body" [options]="fieldExtraordinaryAbility" id="extraordinaryAbility"
                        formControlName="extraordinaryAbility" [disabled]="disabledControls" optionLabel="name"
                        optionValue="id" placeholder="select"> </p-dropdown>
                    <div
                        *ngIf="procesingInformationForm.controls['extraordinaryAbility'].touched && procesingInformationForm.controls['extraordinaryAbility'].invalid">
                        <span class="invalid-message"
                            *ngIf="procesingInformationForm.controls['extraordinaryAbility'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>

                </div>
            </div>
            <div class="form-group" *ngIf="(subTaskDetails.immClassification === 'EB-1a' || this.subTaskDetails.immClassificationCode === 'EB1ALIENSELF')">
                <label class="label-cls required lables-header row col-md-12"><b>Applicable Categories of Documentary
                        Evidence</b> <i
                        pTooltip="To enable Save for this Timeline Step, Select Applicable Category as International Award or select minimum 3 out of 10 evidence."
                        class="pi pi-info-circle info-header"></i></label>
                <div class="row col-md-12">
                    <div class="p-field-checkbox">
                        <p-checkbox id="documentaryEvidence" formControlName="documentaryEvidence"
                            [disabled]="docCheckbox || disabledControls" binary="true">
                        </p-checkbox>
                        <label class="label-cls">Receipt of major, International Recognized Award, such as Nobel Prize,
                            Olympic Medal, etc.</label>
                    </div>
                </div>
            </div>
            <h5 class="checkbox-or" *ngIf="(subTaskDetails.immClassification === 'EB-1a' || this.subTaskDetails.immClassificationCode === 'EB1ALIENSELF')">OR</h5>
            <div class="form-group" formGroupName="threeMajorDocumentaryEvidence"
                *ngIf="(subTaskDetails.immClassification === 'EB-1a' || this.subTaskDetails.immClassificationCode === 'EB1ALIENSELF')">
                <!-- <div class="form-group" formGroupName="address"> -->
                <label class="label-cls lables-header row col-md-12">Select Minimum 3 (Three) of the following.</label>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceReceipt" formControlName="evidenceReceipt"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of receipt of lesser nationally or internationally recognized
                            prizes or awards for excellence</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceAchievement" formControlName="evidenceAchievement"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of your membership in associations in the field which demand
                            outstanding achievement of their members</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidencePublished" formControlName="evidencePublished"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of published material about you in professional or major trade
                            publications or other major media</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceJudge" formControlName="evidenceJudge"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence that you have been asked to judge the work of others, either
                            individually or on a panel</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceSignificance" formControlName="evidenceSignificance"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of your original scientific, scholarly, artistic, athletic, or
                            business-related contributions of major significance to the field</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceAuthorship" formControlName="evidenceAuthorship"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of your authorship of scholarly articles in professional or
                            major trade publications or other major media</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceArtistic" formControlName="evidenceArtistic"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence that your work has been displayed at artistic exhibitions or
                            showcases</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidencePerformance" formControlName="evidencePerformance"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of your performance of a leading or critical role in
                            distinguished organizations</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceSalary" formControlName="evidenceSalary"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence that you command a high salary or other significantly high
                            remuneration in relation to others in the field</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceArts" formControlName="evidenceArts"
                            [disabled]="(procesingInformationForm.get('documentaryEvidence').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of your commercial successes in the performing arts
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-group" formGroupName="personDocumentaryEvidence"
                *ngIf="subTaskDetails.immClassification === 'EB-1b'">
                <h5 class="title required">Documentary Evidence That a Person is an Outstanding Professor or Researcher <i
                        pTooltip="Select at least 2 Evidence to enable Save for this Timeline Step"
                        class="pi pi-info-circle info-header"></i></h5>
                <label class="label-cls lables-header row col-md-12">In order to demonstrate you are an outstanding
                    professor or researcher, you must include evidence of 2 of the 6 listed criteria below (or
                    comparable evidence if any of the criteria do not readily apply):</label>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidencePrice" formControlName="evidencePrice" [disabled]="disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of receipt of major prizes or awards for outstanding
                            achievement</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceMembership" formControlName="evidenceMembership"
                            [disabled]="disabledControls" binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of membership in associations that require their members to
                            demonstrate outstanding achievement</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceProfessional" formControlName="evidenceProfessional"
                            [disabled]="disabledControls" binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of published material in professional publications written by
                            others about the noncitizen's work in the academic field</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidencePanel" formControlName="evidencePanel" [disabled]="disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of participation, either on a panel or individually, as a
                            judge of the work of others in the same or allied academic field</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceResearch" formControlName="evidenceResearch"
                            [disabled]="disabledControls" binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of original scientific or scholarly research contributions in
                            the field</label>
                    </div>
                </div>
                <div class="col-md-12 form-group input-disabled">
                    <div class="p-field-checkbox">
                        <p-checkbox id="evidenceArticals" formControlName="evidenceArticals"
                            [disabled]="disabledControls" binary="true">
                        </p-checkbox>
                        <label class="label-cls">Evidence of authorship of scholarly books or articles (in scholarly
                            journals with international circulation) in the field.</label>
                    </div>
                </div>
            </div>
            <hr />


            <!-- <div class="row mb-3"> IM-23226 issue fix hiding this
                <div class="col-md-6 form-group input-disabled">
                    <label class="label-cls required"> Non-Immigrant visa number from passport </label>
                    <input type="text" class="im-input mw-100" id="nonImmVisaNum" formControlName="nonImmVisaNum"
                        [readOnly]="disabledControls" placeholder="Enter" pInputText />
                    <div
                        *ngIf="procesingInformationForm.controls['nonImmVisaNum'].touched && procesingInformationForm.controls['nonImmVisaNum'].invalid">
                        <span class="invalid-message"
                            *ngIf="procesingInformationForm.controls['nonImmVisaNum'].errors?.required">
                            {{getGlobalErrorMessages('REQUIRED')}}
                        </span>
                    </div>
                </div>
            </div> -->
            <label class="label-cls required lables-header row col-md-12"><b>Information About the Person For Whom You Are Filing</b></label>
            <div class="form-group">
                <div class="row col-12">
                    <div class="p-field-checkbox">
                        <p-checkbox id="willApplForVisaAbrd" formControlName="willApplForVisaAbrd"
                            [disabled]="(procesingInformationForm.get('willApplForAos').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Alien will apply for a visa abroad at the U.S. Embassy or U.S.
                            Consulate
                            at</label>
                    </div>
                </div>
                <div class="row d-flex align-items-center"
                    *ngIf="procesingInformationForm.get('willApplForVisaAbrd').value === true">
                    <div class="col-md-3 form-group processing-dropdown">
                        <label class="label-cls row required"> Country </label>
                        <p-dropdown [options]="countryList" id="visaApplCountryCode"
                            formControlName="visaApplCountryCode" [disabled]="disabledControls"
                            optionLabel="countryName" optionValue="countryCode" placeholder="select"> </p-dropdown>
                        <div
                            *ngIf="procesingInformationForm.controls['visaApplCountryCode'].touched && procesingInformationForm.controls['visaApplCountryCode'].invalid">
                            <span class="invalid-message"
                                *ngIf="procesingInformationForm.controls['visaApplCountryCode'].errors?.required">
                                {{getGlobalErrorMessages('REQUIRED')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-3 form-group input-disabled">
                        <label class="label-cls required"> City</label>
                        <input [readOnly]="disabledControls" type="text" class="im-input mw-100" id="visaApplCity"
                            formControlName="visaApplCity" placeholder="Enter" pInputText />
                        <div
                            *ngIf="procesingInformationForm.controls['visaApplCity'].touched && procesingInformationForm.controls['visaApplCity'].invalid">
                            <span class="invalid-message"
                                *ngIf="procesingInformationForm.controls['visaApplCity'].errors?.required">
                                {{getGlobalErrorMessages('REQUIRED')}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row col-12">
                    <div class="p-field-checkbox">
                        <p-checkbox id="willApplForAos" formControlName="willApplForAos"
                            [disabled]="(procesingInformationForm.get('willApplForVisaAbrd').value === true) || disabledControls"
                            binary="true">
                        </p-checkbox>
                        <label class="label-cls">Alien is in the U.S. and will apply for adjustment of status to that of
                            lawful permanent resident</label>
                    </div>
                </div>
                <div class="row" *ngIf="procesingInformationForm.get('willApplForAos').value === true">
                    <div class="col-md-12 form-group">
                        <label class="label-cls required">Alien's current country of residency or if now in the United
                            states,
                            last
                            country of permanent residence abroad.</label>
                        <div class="row pt-2 processing-dropdown">
                            <div class="col-md-3 pl-0 ">
                                <label class="label-cls row required"> Country</label>
                                <p-dropdown [options]="countryList" id="permResAbrdCountryCode"
                                    formControlName="permResAbrdCountryCode" [disabled]="disabledControls"
                                    optionLabel="countryName" optionValue="countryCode" placeholder="select">
                                </p-dropdown>
                                <div
                                    *ngIf="procesingInformationForm.controls['permResAbrdCountryCode'].touched && procesingInformationForm.controls['permResAbrdCountryCode'].invalid">
                                    <span class="invalid-message"
                                        *ngIf="procesingInformationForm.controls['permResAbrdCountryCode'].errors?.required">
                                        {{getGlobalErrorMessages('REQUIRED')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row col-md-11">
                    <div class="row col-md-11 pl-0">
                        <div class="col-md-10 pl-0 bold-label" name="question">
                            <label class="label-cls">Are you filing any other petitions or applications with this Form
                                I-140</label>
                        </div>
                        <div class="col-md-1">
                            <p-inputSwitch id="anyOthPetFilWithI140" [disabled]="disabledControls"
                                formControlName="anyOthPetFilWithI140"
                                (onChange)="handleDataChange('otherPetTypes', $event);handleDataChange('formsChipList', $event)">
                            </p-inputSwitch>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="procesingInformationForm.get('anyOthPetFilWithI140').value === true">
                    <div class="col form-group" formArrayName="otherPetTypes">
                        <div class="d-flex processing-checkbox pt-1" formGroupName="0">
                            <div *ngFor="let form of listOfForms">
                                <p-checkbox class="pr-5" [disabled]="disabledControls" [id]="form.id" binary="true"
                                    [formControlName]="form.id" [label]="form.name"
                                    (onChange)="handleDataChangeOtherForms($event, form.code)">
                                </p-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showOtherFormsFlag">
                    <div class="col-md-9 form-group processing-dropdown">
                        <label class="label-cls row"> Other Forms </label>
                        <p-chips separator="," [disabled]="disabledControls" class="greenCard-i140-chip" id="otherForms"
                            formControlName="otherForms" placeholder="Enter"></p-chips>
                        <i class="chip-content">Enter multiple names by comma seperated.</i>
                        <div
                            *ngIf="procesingInformationForm.controls['otherForms'].touched && procesingInformationForm.controls['otherForms'].invalid">
                            <span class="invalid-message"
                                *ngIf="procesingInformationForm.controls['otherForms'].errors?.required">
                                {{getGlobalErrorMessages('REQUIRED')}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="row col-md-11">
                    <div class="row col-md-11 pl-0 pb-2">
                        <div class="col-md-10  form-group pl-0 bold-label">
                            <label class="label-cls">Is the person for whom you are filing in removal
                                proceedings?</label>
                        </div>
                        <div class="col-md-1  form-group">
                            <p-inputSwitch [disabled]="disabledControls" id="isPersInRemvlProc"
                                formControlName="isPersInRemvlProc"></p-inputSwitch>
                        </div>
                    </div>
                    <div class="row col-md-11 pl-0 pb-2">
                        <div class="col-md-10 form-group pl-0 bold-label">
                            <label class="label-cls">Has any immigrant visa petition ever been filed by or on behalf of
                                this
                                person?</label>
                        </div>
                        <div class="col-md-1 form-group">
                            <p-inputSwitch [disabled]="disabledControls" id="hasImmVisaFil"
                                formControlName="hasImmVisaFil">
                            </p-inputSwitch>
                        </div>
                    </div>
                    <div class="row col-md-11 pl-0 pb-2">
                        <div class="col-md-10  form-group pl-0 bold-label">
                            <label class="label-cls">Are you filing this petition without an original labor
                                certification
                                because the original labor certification was previously submitted in support of another
                                form
                                I-140?</label>
                        </div>
                        <div class="col-md-1 form-group">
                            <p-inputSwitch [disabled]="disabledControls" id="isFilWithoutLbrCert"
                                formControlName="isFilWithoutLbrCert"></p-inputSwitch>
                        </div>
                    </div>
                    <div class="row col-md-11 pl-0 pb-2">
                        <div class="col-md-10  form-group pl-0 bold-label">
                            <label class="label-cls">If you are filing this petition without an original labor
                                certification, are you requesting the U.S. Citizenship and Immigration Services(USCIS)
                                request a duplicate labor certification from the department of labor (DOL)?</label>
                        </div>
                        <div class="col-md-1 form-group">
                            <p-inputSwitch [disabled]="disabledControls" id="isReqForDupLbrCert"
                                formControlName="isReqForDupLbrCert"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </div>

            <label class="label-cls lables-header row col-md-12"><b>This petition is being filed (select only one )</b></label>
            <div class="form-group">
                <div class="row col-12">
                    <div class="row col-md-10 pl-0 pb-2">
                        <div class="col-md-10 pl-0 bold-label">
                            <label class="label-cls">To amend a previously filed petition.</label>
                        </div>
                        <div class="col-md-1">
                            <p-inputSwitch [disabled]="disabledControls" id="toAmendPrevPetition"
                                formControlName="toAmendPrevPetition"></p-inputSwitch>
                        </div>
                    </div>
                </div>
                <div class="row d-flex align-items-center"
                    *ngIf="procesingInformationForm.get('toAmendPrevPetition').value === true">
                    <div class="col-md-3 form-group processing-dropdown">
                        <label class="label-cls row"> Previous Petition Receipt Number </label>
                        <input [readOnly]="disabledControls" type="text" class="im-input mw-100" id="prevPetitionReceiptNumber"
                            formControlName="prevPetitionReceiptNumber" placeholder="Enter" pInputText />
                        <div
                            *ngIf="procesingInformationForm.controls['prevPetitionReceiptNumber'].touched && procesingInformationForm.controls['prevPetitionReceiptNumber'].invalid">
                            <span class="invalid-message"
                                *ngIf="procesingInformationForm.controls['prevPetitionReceiptNumber'].errors?.required">
                                {{getGlobalErrorMessages('REQUIRED')}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row col-12">
                    <div class="row col-md-10 pl-0 pb-2">
                        <div class="col-md-10 pl-0 bold-label">
                            <label class="label-cls">For the Schedule A, Group I or II designation</label>
                        </div>
                        <div class="col-md-1">
                            <p-inputSwitch [disabled]="disabledControls" id="scheduleAgroupIOrII"
                                formControlName="scheduleAgroupIOrII"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </div>
            <label class="label-cls lables-header row col-md-12"><b>Provide the following information about individual</b></label>
            <div class="form-group">
                <div class="row d-flex align-items-center">
                    <div class="col-md-3 form-group processing-dropdown">
                        <label class="label-cls row"> Occupation </label>
                        <input [readOnly]="disabledControls" type="text" class="im-input mw-100" id="occupation"
                            formControlName="occupation" placeholder="Enter" pInputText />
                    </div>
                </div>
                <div class="row d-flex align-items-center">
                    <div class="col-md-3 form-group processing-dropdown">
                        <label class="label-cls row"> Annual Income $ </label>
                        <input [readOnly]="disabledControls" type="text" class="im-input mw-100" id="annualIncome"
                            formControlName="annualIncome" placeholder="Enter" pInputText />
                    </div>
                </div>
            </div>
        </div>
        <p-divider></p-divider>
        <div class="row pt-3">
            <div class="col-md-2">
                <button pButton type="submit" label="Save" icon="pi pi-save"
                    [ngClass]="checkBoxValidation || procesingInformationForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 btn-success_disabled':'btn-success button-width-icon-left mr-3'"
                    [disabled]="checkBoxValidation || procesingInformationForm.invalid  || disabledControls"></button>
            </div>
            <div class="col-md-2">
                <button pButton type="button" label="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left 
                d-flex alogn-items-center" [disabled]="disabledControls" (click)="handleCancel()">
                </button>
            </div>
            <div class="col-md-2"></div>
            <div class="col-md-6">
                <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
            </div>
        </div>
    </form>
</div>